import { Button, Typography } from "@arco-design/web-react";
import { CirclePlus, Download, HandCoins, NotebookPen, Sparkles, Users } from "lucide-react";

import { resolveAuthUserDisplayName, useCurrentAuthUser } from "../../auth";
import { KpiCard, QuickLinksPanel, RecentActivitiesTable, TodoPanel } from "..";

const { Title, Paragraph, Text } = Typography;

const kpiItems = [
  {
    label: "今日新增线索",
    value: "12",
    trend: "↗ 12%",
    trendTone: "positive" as const,
    icon: <Users size={18} />,
  },
  {
    label: "进行中商机",
    value: "38",
    trend: "↗ 8%",
    trendTone: "positive" as const,
    icon: <Sparkles size={18} />,
  },
  {
    label: "活跃供应商",
    value: "156",
    trend: "↘ 2%",
    trendTone: "negative" as const,
    icon: <HandCoins size={18} />,
  },
  {
    label: "本月预估营收",
    value: "¥328.5万",
    trend: "↗ 15%",
    trendTone: "positive" as const,
    icon: <NotebookPen size={18} />,
  },
];

const activityItems = [
  {
    time: "10:23",
    type: "线索",
    tone: "arcoblue" as const,
    content: "新增销售线索 - 中央美术学院 李老师",
    operator: "张销售",
  },
  {
    time: "09:45",
    type: "报价",
    tone: "green" as const,
    content: "供应商「北京XX酒店」完成报价",
    operator: "王经理",
  },
  {
    time: "09:12",
    type: "商机",
    tone: "orange" as const,
    content: "商机「清华美院4月采风」推进至报价阶段",
    operator: "李计调",
  },
  {
    time: "昨天 18:30",
    type: "订单",
    tone: "green" as const,
    content: "订单「北大艺术学院3月研学」已完成签约",
    operator: "张销售",
  },
];

const todoItems = [
  { title: "待审批报价", count: "06", note: "需在今天 18:00 前完成审批", tag: "紧急" },
  { title: "待分配线索", count: "11", note: "建议按区域与品类自动分配", tag: "跟进" },
  { title: "待确认供应商", count: "04", note: "涉及 4 月重点团期排期确认", tag: "排期" },
];

const quickLinkItems = [
  { label: "进入数据库 Demo", description: "查看链路追踪与数据库连通性。", to: "/demo/sqlserver" },
  { label: "新建客户档案", description: "录入客户基本信息并建立跟进档案。", to: "/crm" },
  { label: "发起报价流程", description: "快速新建标准报价并发送审批。", to: "/finance" },
  { label: "查看供应链协同", description: "集中查看酒店、交通与地接资源。", to: "/supply-chain" },
];

/**
 * 首页工作台页面。
 */
export function WorkspacePage() {
  const currentUserQuery = useCurrentAuthUser();
  const currentUserDisplayName = resolveAuthUserDisplayName(currentUserQuery.data);

  return (
    <div style={{ display: "grid", gap: 24 }}>
      <section
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 20,
          flexWrap: "wrap",
        }}
      >
        <div>
          <Title heading={2} style={{ margin: "0 0 8px", color: "#1d2129" }}>
            欢迎回来，{currentUserDisplayName}
          </Title>
          <Paragraph style={{ margin: 0, color: "#4e5969", fontSize: 16 }}>
            今天是 2026 年 4 月 3 日，星期五，祝您工作愉快。
          </Paragraph>
        </div>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <Button type="secondary" icon={<Download size={16} />}>
            生成报表
          </Button>
          <Button type="primary" icon={<CirclePlus size={16} />}>
            新建商机
          </Button>
        </div>
      </section>

      <section
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: 18,
        }}
      >
        {kpiItems.map((item) => (
          <KpiCard key={item.label} {...item} />
        ))}
      </section>

      <section>
        <RecentActivitiesTable items={activityItems} />
      </section>

      <section
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: 18,
        }}
      >
        <TodoPanel items={todoItems} />
        <QuickLinksPanel items={quickLinkItems} />
      </section>

      <section
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: 20,
          border: "1px solid #e5e6eb",
          background: "linear-gradient(135deg, #ffffff 0%, #f5f9ff 100%)",
          padding: "22px 24px",
        }}
      >
        <div>
          <Text style={{ color: "#165dff", fontWeight: 700 }}>经营提醒</Text>
          <div style={{ marginTop: 8, color: "#1d2129", fontSize: 18, fontWeight: 600 }}>
            本周重点团期进入确认阶段，建议优先处理待审批报价和供应商排期。
          </div>
        </div>
        <Button type="text" style={{ color: "#165dff", fontWeight: 600 }}>
          查看经营周报
        </Button>
      </section>
    </div>
  );
}
